<template>
  <van-address-edit
    :area-list="areaList"
    :show-delete="!isNew"
    show-set-default
    :tel-validator="()=>{return true}"
    :area-columns-num="2"
    :area-columns-placeholder="[$t('common.selectTip'), $t('common.selectTip')]"
    :area-placeholder="$t('common.selectTip')"
    :address-info="addressInfo"
    @save="onSave"
    @delete="onDelete">
    <template #default="">
      <van-field v-model="idNum" :label="$t('address.idNumber')" :placeholder="$t('common.fillTip')" />
      <van-field v-model="tag" :label="$t('address.tag')" :placeholder="$t('common.fillTip')" />
    </template>
  </van-address-edit>
</template>

<script>
import { getAllAddressDetail, deleteAddress, addAddress, amendAddress, setAddressDefault } from '@/api/address'
import { getAllPeruAddress } from '@/api/peruAddress'
import i18n from '@/i18n'
import { Toast } from 'vant'

export default {
  data() {
    return {
      areaList: {},
      addressInfo: {},
      idNum: '',
      tag: '',
      isNew: true
    }
  },
  created() {
    this.areaList = getAllPeruAddress()
    if (this.$route.query.id) {
      this.isNew = false
      getAllAddressDetail().then(rep => {
        rep.data.forEach(a => {
          if (a.id == this.$route.query.id) {
            const addressSplit = a.address.split(',')
            this.addressInfo = {
              id: a.id,
              name: a.contact,
              tel: a.contactNumber,
              province: addressSplit[2],
              city: addressSplit[1],
              areaCode: '',
              addressDetail: addressSplit[0],
              isDefault: a.isDefault
            }
            this.idNum = a.contactIdNum
            this.tag = a.tag
            Object.keys(this.areaList.city_list).forEach(key => {
              if (this.areaList.city_list[key] == this.addressInfo.city) {
                this.addressInfo.areaCode = key
              }
            })
          }
        })
      })
    }
  },
  methods: {
    onSave(content) {
      // 服务端数据结构
      const addressData = {
        id: content.id,
        tag: this.tag,
        detailAddress: content.addressDetail,
        district: [content.province, content.city],
        contact: content.name,
        contactIdNum: this.idNum,
        contactNumber: content.tel,
      }
      if (content.id > 0) {
        // 编辑
        amendAddress(addressData).then(rep => {
          if (content.isDefault) {
            setAddressDefault({ id: content.id }).then(dRep => {
              Toast.success(i18n.t('common.editSuccess'))
              this.$router.push('/address')
            })
          } else {
            Toast.success(i18n.t('common.editSuccess'))
            this.$router.push('/address')
          }
        })
      } else {
        // 新增
        addAddress(addressData).then(rep => {
          Toast.success(i18n.t('common.addSuccess'))
          this.$router.push('/address')
        })
      }
    },
    onDelete() {
      deleteAddress({ id: this.addressInfo.id }).then(rep => {
        Toast.success(i18n.t('common.deleteSuccess'))
        this.$router.push('/address')
      })
    }
  }
}
</script>

<style>
.van-field__label {
  width: 4.3em;
}
</style>